export const SETTINGS_BASE = 'settings/SETTINGS_BASE';
export const STRIPE_VERIFYING = 'settings/STRIPE_VERIFYING';
export const STRIPE_VERIFIED = 'settings/STRIPE_VERIFIED';
export const STRIPE_NOT_VERIFIED = 'settings/STRIPE_NOT_VERIFIED';
export const GET_USER_DATA = 'settings/GET_USER_DATA';
export const SET_USER_DATA = 'settings/SET_USER_DATA';
export const UPDATING_USER_DATA = 'settings/UPDATING_USER_DATA';
